import { Banner } from "@shopify/polaris"
import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import { APICode } from "@/api/APICode"
import dashboard from "@/api/dashboard"
import stores from "@/stores"

interface ShowAccountPlanErrProps {
  onDismiss: () => void
}

const ShowAccountPlanErr: React.FC<ShowAccountPlanErrProps> = ({ onDismiss }) => {
  const navigate = useNavigate()
  const { t } = useTranslation("dashboard", { keyPrefix: "quotaAccountPlan" })

  return (
    <Banner
      title={t("title")}
      action={{
        content: t("upgradeNow"),
        onAction: () => {
          navigate("/billing/plans")
          stores.commonStore.setAccountSource("/dashboard")
        },
      }}
      tone="critical"
      onDismiss={() => {
        dashboard.closeShowAccountTip("show_account_tip")
          .then(res => {
            if (res.data.code === APICode.OK) onDismiss()
          })
      }}
    >
      <p>{t("content")}</p>
    </Banner>
  )
}

export default ShowAccountPlanErr
